module.exports = __webpack_public_path__ + "images/0657510a22f82c8ae884c5dcbf2802b6.png";